import gql from "graphql-tag";

export const accommodationFragment = gql`
    fragment accommodationFragment on Accommodation {
        id
        name
        email
        label
        primary_phone
        secondary_phone
        fax
        street
        town
        state
        country
        zipcode
        website
        deleted_at

        note
        internal_notes
    }
`